export default {
      id: "notifications__alert.sos-usage",
      viewBox: "0 0 38 38",
      url: __webpack_public_path__ + "img/icons.svg#notifications__alert.sos",
      toString: function () {
        return this.url;
      }
    }